import { Button, Drawer, Callout } from "@blueprintjs/core";

import { Flex } from "@/components/layout/flexbox";
import { BasicTab } from "@/components/pages_logged_in/roleplays/details/scenario/edit/BasicTab";
import { CharacterTab } from "@/components/pages_logged_in/roleplays/details/scenario/edit/CharacterTab";
import { ScenarioTab } from "@/components/pages_logged_in/roleplays/details/scenario/edit/ScenarioTab";
import { useEditScenario } from "@/components/pages_logged_in/roleplays/details/scenario/edit/useEditScenario";
import Tabs from "@/components/pieces/Tabs";
import { DARK_BACKGROUND } from "@/css/constants";
import { ScenarioType } from "@/graphql";

export function EditScenario({
  open,
  onClose,
  scenario,
}: {
  open: boolean;
  onClose: () => void;
  scenario?: ScenarioType;
}) {
  const { state, dispatch, handleSave, loading, disabled } = useEditScenario(
    scenario,
    onClose,
  );

  return (
    <Drawer
      isOpen={open}
      usePortal={true}
      lazy={true}
      onClose={onClose}
      title="Edit Scenario"
      style={{
        maxWidth: "600px",
        width: "100%",
        height: "100%",
      }}
    >
      {state.error && <Callout intent="danger">{state.error}</Callout>}
      <Flex flexDirection="column" overflowY="auto" className="flex-auto">
        <div
          className="border-b border-gray-300 px-6"
          style={{
            backgroundColor: DARK_BACKGROUND,
          }}
        >
          <Tabs
            backgroundColor={DARK_BACKGROUND}
            tabs={[
              { key: "basic", label: "Basic Details" },
              { key: "scenario", label: "Scenario Details" },
              { key: "character", label: "Character Details" },
            ]}
            tab={state.tab}
            onTabChange={(tab) => {
              dispatch({ type: "setTab", payload: tab.key });
            }}
          />
        </div>
        {state.tab === "basic" && (
          <BasicTab state={state} dispatch={dispatch} />
        )}
        {state.tab === "scenario" && (
          <ScenarioTab state={state} dispatch={dispatch} />
        )}
        {state.tab === "character" && (
          <CharacterTab persona={state.persona} dispatch={dispatch} />
        )}
      </Flex>
      <Flex justifyContent="flex-start" p={24} className="bts">
        <Button
          loading={loading}
          intent="primary"
          large={true}
          onClick={handleSave}
          disabled={disabled}
        >
          Save
        </Button>
      </Flex>
    </Drawer>
  );
}
